import { errorColor } from "../../colors";
import "./datePicker.css";

export const datePickerStyle = {
  width: "100%",
  borderTopRightRadius: "0",
  borderBottomRightRadius: "0",
  borderColor: "#E2E8F0",
  padding: "0 16px",
  zIndex: "10",
};

export const datePickerErrorStyle = {
  borderColor: errorColor,
  boxShadow: "0 0 0 1px #E53E3E",
};
